export default {
  path: 'common',
  name: 'Common',
  childRoutes: [],
};
